export default "__VITE_ASSET__DN2uU4zT__"